/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTiposUnidadesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTiposUnidades: React.FunctionComponent<ITablaTiposUnidadesVistaProps & InjectedIntlProps> = ({
    tiposUnidadess,
    cargarTiposUnidades,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tiposUnidadess}
            actions={acciones(manejarFormulario, cargarTiposUnidades, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTiposUnidades);
